module.exports = __webpack_public_path__ + "static/crown-10a077ce49af2cbd7c1178e9aecd58c9.mp4";